module.exports = __webpack_public_path__ + "img/right_md_2.f266454f.jpg";